// extracted by mini-css-extract-plugin
module.exports = {"fileDropZone":"FileDropZone_fileDropZone__9YDX7","fileDropZoneContainer":"FileDropZone_fileDropZoneContainer__15yYQ","fileDropZoneInput":"FileDropZone_fileDropZoneInput__2Bo9V"};